<template>
  <svg
    version="1.1"
    id="_x31_0"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
    x="0px"
    y="0px"
    viewBox="0 0 512 512"
    style="width: 16px; height: 16px; opacity: 1;"
    xml:space="preserve"
  >
    <g>
      <path
        class="st0"
        d="M256,0C114.614,0,0,114.614,0,256s114.614,256,256,256c141.383,0,256-114.614,256-256S397.383,0,256,0z
		M323.238,355.254l-0.551,6.504c-1.793,21.313-7.133,36.27-16.332,45.723c-9.242,9.507-20.777,14.328-34.285,14.324
		c-9.426,0-18.004-2.496-25.496-7.406c-7.562-4.957-13.191-12.012-16.726-20.965c-3.391-8.602-4.965-22.617-4.813-42.824v-74.149
		c0-11.75-1.102-15.722-1.578-16.886c-0.898-2.184-2.378-3.954-4.531-5.383c-0.137-0.086-1.554-0.797-6.809-0.797
		c-0.308,0.016-2.484,0.238-11.206,3.078l-5.582,1.828l-6.566-18.61l70.188-28.519h15.75v148.5c0,15.816,2.641,20.871,3.782,22.312
		c2.226,2.817,5.199,4.133,9.367,4.133c2.87,0,5.25-1.222,7.484-3.851c1.469-1.73,4.262-6.879,6.398-21.863l0.738-5.16h19.285
		L323.238,355.254z M249.817,170.058c-21.786,0-39.84-18.054-39.84-39.84c0-29.258,28.637-41.706,39.84-39.839
		c21.789,3.734,39.835,21.164,39.835,41.706C289.652,147.649,275.34,170.058,249.817,170.058z"
        style="fill: rgb(75, 75, 75);"
      />
    </g>
  </svg>
</template>
<style scoped>
.st0 {
  fill: #374149;
}
</style>
